import { List } from "immutable";

export default {
  /**
   * 航跡管理追加
   *
   * @param state
   * @param payload
   * @constructor
   */
  CREATE: (state, payload) => {
    state.list = List(payload.vessels);
    state.max = payload.count;
  },
  /**
   * 全データクリア
   *
   * @param state
   * @constructor
   */
  CLEAR: (state) => {
    state.list = null;
    state.max = 0;
  }
}
